export { default } from './SWBannerCarousel';